import React from 'react'
import { useSection } from '../../../__helpers/use-section-meta'
import { StyledLogoWrapLink } from './MastheadLogo.styled'
import { TheNightlyHorizontalLogo } from '../../../logos/TheNightlyLogo/TheNightlyHorizontalLogo'

interface MastheadLogoProps {
    width?: number
    height?: number
    fillColor?: string
    isFooterLogo?: boolean
}

export const MastHeadLogo: React.FC<MastheadLogoProps> = ({
    width,
    height,
    fillColor,
}) => {
    const websiteSection = useSection()

    return (
        <StyledLogoWrapLink
            section={websiteSection}
            to={'/'}
            id={`header-logo`}
        >
            <InternalMastheadLogo
                width={width}
                height={height}
                fillColor={fillColor}
            />
        </StyledLogoWrapLink>
    )
}

export const InternalMastheadLogo: React.FC<MastheadLogoProps> = ({
    width = 400,
    height = 52,
    fillColor,
}) => {
    return (
        <TheNightlyHorizontalLogo
            fillColor={fillColor}
            logoWidth={width}
            logoHeight={height}
        />
    )
}
